export class NameSpaced {
    constructor(namespace = "svg:") {
        this.namespace = namespace;
    }
}
// export type D3ElementSelection =
// | d3.Selection<SVGGElement, undefined, null, undefined>
// | d3.Selection<Element, undefined, null, undefined>
// | d3.Selection<Element, unknown, HTMLElement, any>;
export class D3Element extends NameSpaced {
}
//# sourceMappingURL=D3Element.js.map